import { render } from "./SawitBuahTable.vue?vue&type=template&id=1dac3ba2"
import script from "./SawitBuahTable.vue?vue&type=script&lang=js"
export * from "./SawitBuahTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__